import React, { Component } from 'react';
import DefaultLayout from '../../Layout/components/DefaultLayout'
import { LoggedInLayoutProps } from '../connected/LoggedInLayoutCnn';
import { withRouter } from 'react-router';


class LoggedInLayout extends Component<LoggedInLayoutProps> {

    componentDidMount() {
        if (this.props.isAuthenticated === false || this.props.isAuthenticated === null)
            this.props.history.push("/Login")
    }

    componentDidUpdate() {
        if (this.props.isAuthenticated === false || this.props.isAuthenticated === null)
            this.props.history.push("/Login")
    }

    render() {
        return (
            <div>
                {this.props.isAuthenticated &&
                    <DefaultLayout {...this.props} isPublic={false} hideError={this.props.hideError} showError={this.props.showError} errorMessage={this.props.errorMessage} isAuthenticated={this.props.isAuthenticated}></DefaultLayout>
                }
            </div>
        );
    }
}

export default withRouter(LoggedInLayout);
